// src/utils/request.js
import axios from 'axios';
import { ElMessage } from 'element-plus';
// 如果使用 Vue Router 来跳转
// import router from '@/router'; // 假设你的 router 实例路径

// 从环境变量获取 baseURL，提供一个开发环境的默认值
const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8081/manage/api';

// 创建 axios 实例
const service = axios.create({
  baseURL: baseURL,
  timeout: 10000, // 请求超时时间 ms
  headers: {
    'Content-Type': 'application/json;charset=utf-8', // 默认请求头
    'Accept': 'application/json, text/plain, */*',
  }
});

// --- 请求拦截器 ---
service.interceptors.request.use(
  (config) => {
    // 统一添加 token
    const token = localStorage.getItem('token'); // 考虑封装 getToken() 函数
    if (token) {
      // 根据你的后端要求设置 Token Header，常见的有 Authorization: Bearer <token>
      config.headers['X-Token'] = token; // 或者 config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 请求错误处理
    console.error('Request Error:', error); // for debug
    return Promise.reject(error);
  }
);

// --- 响应拦截器 ---
service.interceptors.response.use(
  /**
   * 通过自定义 code 判断请求状态，这里只是一个例子，请根据实际业务调整。
   * 也可以通过 HTTP 状态码直接判断。
   */
  (response) => {
    const res = response.data;

    // -- 根据你的后端响应结构调整 --
    // 假设 code 为 20000 代表成功
    if (res.code === 20000) {
      return res; // 直接返回后端返回的完整数据结构 { code, message, data }
      // 或者 return res.data; // 如果只需要业务数据部分
    } else {
      // 处理业务错误 (code 不是 20000)
      ElMessage({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });

      // 可以根据 code 做特殊处理，例如：
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // 处理 Token 无效或过期的情况
      //   console.log('Token expired or invalid, redirecting to login.');
      //   localStorage.removeItem('token');
      //   window.location.href = '/login'; // 或者 router.push('/login');
      // }

      // 将业务错误视为 reject，让调用处的 .catch() 能捕获到
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  (error) => {
    // 处理 HTTP 网络错误
    console.error('Response Error:', error); // for debug
    let message = error.message;
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '认证失败，请重新登录';
          // 执行登出操作
          localStorage.removeItem('token');
          window.location.href = '/login'; // 或者 router.push('/login');
          break;
        case 403:
          message = '您没有权限访问此资源';
          break;
        case 404:
          message = '请求的资源未找到';
          break;
        case 500:
          message = '服务器内部错误';
          break;
        // ... 其他状态码处理
        default:
          message = `连接错误 ${error.response.status}`;
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      message = '网络超时，请检查网络连接';
    } else {
      // 设置请求时发生了一些事情，触发了错误
      message = '请求失败，请稍后重试';
    }

    ElMessage({
      message: message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error); // 返回原始错误对象或一个新的错误对象
  }
);

export default service; // 导出配置好的 Axios 实例